import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { project }: Boundaries["editProjectWeatherReport"]["request"],
): State {
  const index = state.findIndex((res) => res.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { project }: Boundaries["editProjectWeatherReport"]["success"],
): State {
  return state.map((request) =>
    request.project.uuid === project.uuid
      ? { project, request: setRequestStateToSuccess() }
      : request,
  );
}

function handleFailure(
  state: State,
  { project }: Boundaries["editProjectWeatherReport"]["failure"],
): State {
  return state.map((request) =>
    request.project.uuid === project.uuid
      ? { project, request: setRequestStateToFailure() }
      : request,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editProjectWeatherReportRequested]: handleRequest,
    [events.editProjectWeatherReportSucceeded]: handleSuccess,
    [events.editProjectWeatherReportFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
